import { Directive, Input, Renderer2, ElementRef, OnInit, EventEmitter, Output } from '@angular/core';
import { isString } from '../../models/utils';

@Directive({
    standalone: false,
    selector: '[resIconSwitch]'
})
export class IconSwitchDirective implements OnInit {

    @Input() initClass: string;
    @Input() switchClass: string;
    @Input() elementAttributeName: string;
    @Input() elementAttributeValue: string;
    @Input() automationId: string;
    @Output() visibilityEvent = new EventEmitter<string>();

    private iconElement: HTMLElement;
    private elementInitAttributeValue: string;

    constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

    ngOnInit(): void {
        if (isString(this.initClass)) {
            this.iconElement = this.renderer.createElement('i');
            this.renderer.setAttribute(this.iconElement, 'class', this.initClass);
            if (this.automationId) {
                this.renderer.setAttribute(this.iconElement, 'data-automation-id', this.automationId);
            }
            // If element is an input, add the image to its parent since inputs cannot have children elements
            if (this.elementRef.nativeElement.nodeName === 'INPUT') {
                this.renderer.appendChild(this.elementRef.nativeElement.parentElement, this.iconElement);
            } else {
                this.renderer.appendChild(this.elementRef.nativeElement, this.iconElement);
            }
        }
        // Save initial value of an attribute in case the directive has to switch an attribute value
        if (isString(this.elementAttributeName) && isString(this.elementAttributeValue)) {
            this.elementInitAttributeValue = this.elementRef.nativeElement.getAttribute(this.elementAttributeName);
        }
        if (this.iconElement) {
            this.iconElement.addEventListener('click', () => {
                this.visibilityEvent.emit('');
                if (isString(this.elementInitAttributeValue)) {
                    if (this.elementRef.nativeElement.getAttribute(this.elementAttributeName) === this.elementInitAttributeValue) {
                        this.renderer.setAttribute(this.elementRef.nativeElement, this.elementAttributeName, this.elementAttributeValue);
                    } else {
                        this.renderer.setAttribute(this.elementRef.nativeElement, this.elementAttributeName, this.elementInitAttributeValue);
                    }
                }
                if (this.switchClass) {
                    if (this.iconElement.className === this.initClass) {
                        this.renderer.setAttribute(this.iconElement, 'class', this.switchClass);
                    } else {
                        this.renderer.setAttribute(this.iconElement, 'class', this.initClass);
                    }
                }
            });
        }
    }
}
